<template>
  <div class="Codex"> 
  <transition name="Codex__thumbnail">
    <div class="Codex__thumbnail" v-if="slugIsAfter('12')">
      <img v-lazy="require('./img/codex_large.png')" class="Vlazy"/>
    </div>
  </transition>
  <transition name="Codex__large" appear>
    <div class="Codex__large" v-if="slugIsIn(['10', '11', '12'])">
      <img v-lazy="require('./img/codex_large.png')" class="Vlazy"/>
    </div>
  </transition>
  <Stickers v-if="slugIsIn(['16', '17', '20', '21', '23', '24'])" />
  </div>
</template>

<script>
import Stickers from './Stickers'

export default {
  name: 'Codex',
  components: { Stickers },
  data: () => ({}),
  translations: {
    fr: {},
    en: {},
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
      }
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Codex
  pointer-events none
  position relative
  width 100%
  height 100vh

  &__thumbnail
    position absolute
    width 118px
    height 118px
    top 70px
    right 24px 
    transition opacity 1s, transform 1s

    &-enter
    &-leave-active
      transform scale(.5)
      opacity 0

  &__large
    position absolute
    transform translate(-50%, -50%)
    top 50%
    left 50%
    width 300px
    transition opacity 1s, transform 1s

    &-enter
    &-leave-active
      transform translate(-50%, -50%) scale(.5)
      opacity 0
    
</style>



// WEBPACK FOOTER //
// src/components/inventory/Codex.vue